import React from 'react';

import { useAddressFormContext } from '../../context';
import { CityField } from '../../fields/city';
import { CompanyField } from '../../fields/company';
import { CountryField } from '../../fields/country';
import { EmailField } from '../../fields/email';
import { Line1Field } from '../../fields/line1';
import { Line2Field } from '../../fields/line2';
import { Line3Field } from '../../fields/line3';
import { NameField } from '../../fields/name';
import { PhoneField } from '../../fields/phone';
import { PostalCodeField } from '../../fields/postal-code';
import { StateField } from '../../fields/state';
import style from '../../style.module.less';

export const GBFields = () => {
  const { line3 } = useAddressFormContext();

  return (
    <>
      <NameField />
      <CompanyField optional />
      <CountryField />
      <Line1Field />
      <Line2Field />
      {line3 && <Line3Field />}
      <div className={style['two-column-row']}>
        <CityField />
        <StateField />
      </div>
      <PostalCodeField />
      <PhoneField optional />
      <EmailField optional />
    </>
  );
};
